<template>
  <div class="order-card">
    <div :class="['order-container']">
      <div class="order-image">
        <img :src="productMention.imageUrl" />
      </div>
      <div class="order-details">
        <div>
          <div class="mb-2">{{ productMention.message }}</div>
          <span
            class="see-detail pointer w-auto"
            @click="handleOpenTab(productMention.externalLink)"
          >
            {{ $t("viewDetail") }}
          </span>
        </div>
        <!-- <div class="d-flex">
          <div class="mr-2 order-status">ที่ต้องจัดส่ง</div>
          <div>จัดส่งภายใน: 29-08-2025</div>
        </div>
        <div>
          <span>สินค้า 1 ชิ้น, </span>
          <span>คำสั่งซื้อทั้งหมด: ฿0</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatOrderCard",
  props: {
    productMention: {
      required: false,
      type: Object
    }
  },
  methods: {
    handleOpenTab(url) {
      console.log(this.productMention);

      if (url) window.open(decodeURIComponent(url), "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.order-container {
  display: flex;
  min-height: 40px;
  background-color: #fafafa;
  border-radius: 6px;
  font-size: 14px;

  &.clickable {
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .order-image {
    width: 60px;
    height: 100%;
    flex-shrink: 0;
    overflow: hidden;
    border: 1px solid #f1f1f1;
    border-radius: 6px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .order-details {
    flex: 1;
    padding: 5px 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .see-detail {
      color: #832abf;
      font-size: 13px;
    }

    .order-status {
      color: #ee4d2d;

      + div {
        color: #9c9c9c;
      }
    }
  }
}

/* Responsive adjustments */
@media (max-width: 480px) {
}
</style>
